import React from 'react';
import './NewsPage.css';

export default function NewsPage() {
  return (
    <div className="news-container">
      <h1>ChronoTech Robotics News</h1>
      <p>Stay up to date with product updates, events, and announcements.</p>

      <section className="featured-news">
        <h2>🚀 Robo Kids Program Expands to 4 Levels!</h2>
        <p>
          As of August 2025, our robotics courses now offer four tiers of learning — from beginner to advanced innovation. Each class is hands-on, live, and includes a full kit shipped to your home.
        </p>
        <span className="date">Posted: August 18, 2025</span>
      </section>

      <section className="news-list">
        <h3>More Updates</h3>
        <ul>
          <li>
            <strong>🛒 Shop Now Open:</strong> Our online store for kits and accessories is live! <span className="date">August 10, 2025</span>
          </li>
          <li>
            <strong>🎉 50+ Students Enrolled:</strong> Thanks to all our early families for joining the Robo Kids Learning pilot. <span className="date">August 1, 2025</span>
          </li>
        </ul>
      </section>
    </div>
  );
}
